import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlProjectStatus } from "~/__generated__";

type Props = {
    value: GqlProjectStatus[];
    onChange: (value: GqlProjectStatus[]) => void;
    sx?: SxProps<Theme>;
};

export default function ProjectStatusSelect({ value, onChange, sx }: Props) {
    const { t } = useTranslation("project");

    const options = Object.values(GqlProjectStatus).map(status => ({
        value: status,
        label: t(`ProjectStatusSelect.projectStatusValue.${status}`),
    }));

    const selectedOptions = options.filter(o => value.includes(o.value));

    return (
        <Autocomplete
            multiple
            size="small"
            sx={sx}
            options={options}
            value={selectedOptions}
            onChange={(_, newValues) => onChange(newValues.map(o => o.value))}
            getOptionLabel={option => option.label}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            renderInput={params => <TextField {...params} label={t("ProjectStatusSelect.labelStatus")} variant="outlined" />}
        />
    );
}
